export const matchMobile = window.matchMedia('(min-width: 768px)');

export const { theme } = window;

export const apiProxy = `${window.location.origin}/apps/barbecook`;

export const getAkeneoLocale = () => {
  const domainSuffix = window.location.host.split('.').pop();
  const { lang } = document.documentElement;

  if (lang === 'de') {
    return 'de_DE';
  }

  if (lang === 'es') {
    return 'es_ES';
  }

  if (lang === 'it') {
    return 'it_IT';
  }

  if (lang === 'fr' && domainSuffix === 'be') {
    return 'fr_BE';
  }

  if (lang === 'fr' && domainSuffix === 'lu') {
    return 'fr_LU';
  }

  if (lang === 'fr') {
    return 'fr_FR';
  }

  if (lang === 'nl' && domainSuffix === 'be') {
    return 'nl_BE';
  }

  if (lang === 'nl') {
    return 'nl_NL';
  }

  return 'en_GB';
};

export const rootPath =
  theme && theme.routes && theme.routes.root !== '/' ? `${theme.routes.root}/` : '/';
